import { render } from "./tokyo-catch-input-packing.vue?vue&type=template&id=242bd5a8&scoped=true"
import script from "./tokyo-catch-input-packing.vue?vue&type=script&lang=js"
export * from "./tokyo-catch-input-packing.vue?vue&type=script&lang=js"

import "./tokyo-catch-input-packing.vue?vue&type=style&index=0&id=242bd5a8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-242bd5a8"]])

export default __exports__